import { motion } from "framer-motion";
import { Lock, Sparkles, ArrowRight } from "lucide-react";
import { Button } from "./button";

export function PremiumPaywall({ message, title = "Limite de Inteligência Atingido" }: { message?: string, title?: string }) {
    return (
        <motion.div 
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            className="flex flex-col items-center justify-center p-8 lg:p-12 text-center bg-zinc-900 rounded-3xl text-white shadow-2xl relative overflow-hidden"
        >
            {/* Dark/Glassmorphism Premium feel */}
            <div className="absolute inset-0 bg-gradient-to-br from-indigo-500/10 via-teal-500/10 to-purple-500/10 pointer-events-none" />
            <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-zinc-800 via-zinc-900 to-black opacity-80 pointer-events-none" />
            
            <motion.div
                initial={{ y: -20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.2 }}
                className="relative z-10 bg-indigo-500/20 p-4 rounded-2xl mb-6 border border-indigo-500/30 shadow-inner"
            >
                <Lock className="w-10 h-10 text-indigo-300" />
            </motion.div>

            <motion.h2 
                initial={{ y: 20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.3 }}
                className="relative z-10 text-3xl font-bold mb-4 bg-clip-text text-transparent bg-gradient-to-r from-teal-200 to-indigo-200"
            >
                {title}
            </motion.h2>

            <motion.p 
                initial={{ y: 20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.4 }}
                className="relative z-10 text-zinc-300 max-w-lg mb-8 text-lg leading-relaxed"
            >
                {message || "Sua cota deste ciclo esgotou. A IA continuou analisando sua clínica e descobriu novas oportunidades. Faça o upgrade para acessá-las ilimitadamente."}
            </motion.p>

            <motion.div 
                initial={{ y: 20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.5 }}
                className="relative z-10 flex flex-col sm:flex-row gap-4 w-full justify-center"
            >
                <Button 
                    size="lg" 
                    className="bg-indigo-600 hover:bg-indigo-500 text-white border-0 shadow-lg shadow-indigo-600/30 rounded-xl h-12 px-8 group"
                    onClick={() => window.location.href = "/dashboard/billing"}
                >
                    <Sparkles className="w-4 h-4 mr-2 text-indigo-200" />
                    Fazer Upgrade para Licença Premium
                    <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                </Button>
                <Button 
                    variant="outline" 
                    size="lg" 
                    className="bg-transparent border-zinc-700 text-zinc-300 hover:bg-zinc-800 hover:text-white rounded-xl h-12 px-8"
                    onClick={() => window.history.back()}
                >
                    Voltar
                </Button>
            </motion.div>
        </motion.div>
    );
}
